import { useWebSocketApi } from '@e3dc-react/shell/Hooks'
import { isUndefined } from 'lodash'
import { FetchingState, RechartData } from 'src/Libs/chart-kit'
import { StorageAutarkyDto } from 'src/Libs/storage/api/dto'
import { StorageAutarky } from 'src/Libs/storage/models/storage.models'
import { fromAutarkyDtoToModel } from 'src/Libs/storage/transformers/from-autarky-dto-to-model.transformer'

const SERVICE_ID = '[AUTARKY PIECHART VALUES]'

/**
 * Hook that returns the autarky PieChart values for a specific storage.
 */
export const useAutarkyChartValues = (storageId?: string, doNotInitialize?: boolean): RechartData => {
  const { socketState } = useWebSocketApi<StorageAutarky, StorageAutarkyDto>({
    apiResourcePath: `storages/${storageId}/status/autarky/ws`,
    loggerKey: SERVICE_ID,
    transformer: fromAutarkyDtoToModel,
    dependencies: [storageId],
    doNotInitialize: isUndefined(storageId) || doNotInitialize,
    endpoint: process.env.REACT_APP_API_ENDPOINT ?? '',
  })

  const chartData = {
    loadingState: {
      state: socketState.data ? FetchingState.Completed : FetchingState.IsFetching,
    },
    sums: {
      Autarky: { history: socketState.data?.autarkyPercentage ?? 0 },
      NetOut: { history: socketState.data?.gridImportPercentage ?? 0 },
      ThreeSixtySavings: { history: socketState.data?.gridImport360Percentage ?? 0 },
      NetOutWithoutThreeSixtySavings: { history: socketState.data?.gridImportPercentage ?? 0 },
    },
  }

  return chartData
}
